import React from 'react'
import PropTypes from 'prop-types';
// import application_contants from '../../../contants/application_contants';

// Import your logos (adjust paths as needed)
// import BhashiniLogo from './assets/bhashini.png'
// import IIScLogo      from './assets/iisc.png'
// import ArtparkLogo   from './assets/artpark.png'
// import GIZLogo       from './assets/giz.png'
// import SammaanLogo   from './assets/sammaan.png'

export default function Hack4tts_dataset({ section_id }) {
   return (
    <section id={section_id} className="about-readmore-section">
      <div className="about-content">
        {/* <p className="about-subtitle title-navy-blue">Know More About Datasets</p> */}
        <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Datasets</h2>
        <p className="jostRegular h5-small section-title title-dark-grey about-readmore-text">
          The SYSPIN Dataset is a groundbreaking resource developed by SPIRE Lab, IISc Bangalore, in collaboration with Bhashini AI Solutions Pvt Ltd. It is supported by the German Development Cooperation project FAIR Forward - AI for All and (GIZ) and the Digital India Bhashini Division aimed at revolutionising open-source voice technology for diverse Indian languages.
        </p>
        <p className="jostRegular h5-small section-title title-dark-grey about-readmore-text">
          This dataset includes text-to-speech (TTS) corpora for 9 Indian languages: Hindi, Bengali, Marathi, Telugu, Bhojpuri, Kannada, Magadhi, Chhattisgarhi, and Maithili, with recordings from 2 speakers (1 male and 1 female) per language. Each speaker contributed over 40 hours of high-quality speech, ensuring naturalness and clarity, verified through rigorous quality checks involving local and native speakers.
        </p>
        <p className="jostRegular h5-small section-title title-dark-grey about-readmore-text">
          The SPICOR dataset developed in SPIRE Lab, IISc Bangalore, will also be provided. The SPICOR dataset includes English and Gujarati languages, each featuring two speakers (one male and one female).
        </p>
        <p className="jostRegular h5-small section-title title-dark-grey about-readmore-text">
          The SYSPIN and SPICOR datasets, alongside baseline TTS models, empower innovations in industries such as agriculture, healthcare, education, and finance, enabling the development of inclusive and accessible voice technologies. Additionally, the participants are encouraged to use external open-source datasets to build and train the models.
        </p>

      </div>

      
    </section>
  )
}

Hack4tts_dataset.propTypes = {
  section_id: PropTypes.string.isRequired
}
